import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicSite from "@/pages/PublicSite";
import PreviewSite from "@/pages/PreviewSite";
import Privacy from "@/pages/Privacy";
import AdminLogin from "@/pages/AdminLogin";
import AdminPanel from "@/pages/AdminPanel";

const Loading = () => (
  <div className="min-h-screen bg-[#08080A] flex items-center justify-center" data-testid="auth-loading">
    <div className="h-px w-24 bg-white/20 overflow-hidden">
      <div className="h-full w-1/2 bg-[#C5A059] animate-pulse" />
    </div>
  </div>
);

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/privacidade" element={<Privacy />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><AdminPanel /></Protected>} />
            <Route path="/preview" element={<Protected><PreviewSite /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-center" richColors />
      </AuthProvider>
    </MotionConfig>
  );
}

export default App;
